import type { FaqContent } from '../types';

/** Support/FAQ content aligned with legacy visime.ch/faq topics (WP export unavailable). */
export const faqDe: FaqContent = {
  title: 'Hilfe & Support',
  description: 'Antworten auf häufige Fragen zu VisiMe, VISI, ME und Abonnements.',
  updated: '2026-03-22',
  items: [
    {
      question: 'Was ist der Unterschied zwischen VISI und ME?',
      answer:
        'VISI ist Ihre öffentliche digitale Visitenkarte mit allen verlinkten Kanälen und optionaler Standortsichtbarkeit. ME ist Ihr privates Nutzerprofil für Suche, Favoriten und Listen — ME ist nicht öffentlich sichtbar.',
    },
    {
      question: 'Wie lade ich die App herunter?',
      answer:
        'VisiMe ist im Apple App Store und bei Google Play verfügbar. Nutzen Sie die Download-Buttons auf der Landing Page oder suchen Sie nach «VisiMe» im Store Ihres Geräts.',
    },
    {
      question: 'Welche Abonnements gibt es?',
      answer:
        'ME ist kostenlos. Für ein öffentliches VISI stehen VISI Single, VISI Duo und VISI Promoter zur Verfügung — Details und Preise finden Sie auf der Landing Page unter Preisplan.',
    },
    {
      question: 'Kann ich steuern, wer mein VISI sieht?',
      answer:
        'Ja. In der App können Sie die Sichtbarkeit Ihres VISI jederzeit ein- und ausschalten und zwischen fester Adresse und GPS-Standort wählen.',
    },
    {
      question: 'Wie melde ich mich auf visime.com an?',
      answer:
        'Öffnen Sie visime.com und wählen Sie «Anmelden». Die Anmeldung erfolgt über E-Mail oder unterstützte SSO-Anbieter gemäss den Bildschirmhinweisen.',
    },
    {
      question: 'Wo finde ich Datenschutz und Impressum?',
      answer:
        'Links zu Datenschutzerklärung, Nutzungsbedingungen, Cookie-Richtlinie und Impressum finden Sie in der Fusszeile jeder Marketing-Seite unter visime.com.',
    },
    {
      question: 'Wie erreiche ich den Support?',
      answer: 'Schreiben Sie an support@visime.com. Bitte beschreiben Sie Ihr Anliegen und nennen Sie die verwendete App-Version sowie Ihr Gerät.',
    },
  ],
};
